<ng-container *transloco="let t;">
<div class="container verification-page-inner-container" *ngIf="!loadVerification">
    <div class="verification-document-row mt-25">
        <div class="verification-row mt-0">
            <div class="verification-document-column left-column">
                <h3 class="document-name">{{verification?.visible_name ?? verification?.name}}</h3>
                <div class="flex-box-column">
                    <div class="flex-column left-column sub-text-label">{{t("Verification date text (Verification page) - Verification date")}}:</div>
                    <div class="flex-column right-column sub-text-label-bold">{{verification?.updated_at | dateFormat | async}}</div>
                </div>
                <div class="flex-box-column">
                    <div class="flex-column left-column sub-text-label">{{t("Verification time zone text (Verification page) - Time zone")}}:</div>
                    <div class="flex-column right-column sub-text-label-bold">{{ 'offset' | getTimezoneOffset | async }}</div>
                </div>
                <div class="flex-box-column">
                    <div class="flex-column left-column sub-text-label">{{t("Verification Attachments text (Verification page) - Attachments")}}:</div>
                    <div class="flex-column right-column sub-text-label-bold">{{verification?.number_of_attachments}}</div>
                </div>
            </div>
    
            <div class="verification-document-column right-column pe-0">
                <h2 class="verification-page-title">{{t("Verification text (Verification page) - Verification")}}</h2>
                <div><span>{{t("Verification transaction text (Verification page) - Transaction")}}:</span><span class="ps-25">{{verification?.document_number}}</span></div>
            </div>
        </div>
    </div>

    <div class="verification-document-row verification-participant-row">
        <h2 class="verification-page-title">{{t("Sidebar tab title (general) - Participants")}}</h2>

        <div class="verification-row-participant">
            @for (party of verification?.recipient_roles; track party.id) {
                <ng-container *ngIf="party?.recipient_role_detail?.is_sender === 1; else nonSender">
                    <div class="verification-document-column-participant">
                    <div class="flex-box-column flex-box-column-participant">
                        <div class="participant-info-box">
                            <div class="flex-row full-column participant-name">
                                {{party?.user?.name}}
                                <ng-container *ngIf="party?.recipient_role_detail?.signature_image; else senderSigner">
                                    <span class="badge badge-light-primary">{{t("Verification initiator and signer text (Verification page) - Initiator and Signer")}}</span>
                                </ng-container>
                                <ng-template #senderSigner>
                                    <span class="badge badge-light-primary">{{t("Verification initiator text (Verification page) - Initiator")}}</span>
                                </ng-template> 
                            </div>
                            <div class="flex-column full-column sub-text-label" *ngIf="party?.workspace?.organization">
                                 {{party?.workspace?.organization}}<span *ngIf="party?.workspace?.registration_number">({{party?.workspace?.registration_number}})</span>
                            </div>
                            <div class="flex-column full-column sub-text-label" *ngIf="party?.workspace?.address || party?.workspace?.zipcode || party?.workspace?.city">
                                <span *ngIf="party?.workspace?.address">{{party?.workspace?.address}}</span>
                                <span *ngIf="party?.workspace?.zipcode || party?.workspace?.city">,</span> 
                                <span *ngIf="party?.workspace?.zipcode"> {{party?.workspace?.zipcode}}</span> 
                                <span *ngIf="party?.workspace?.city"> {{party?.workspace?.city}}</span>
                            </div>
                            <div class="flex-column full-column sub-text-label">
                                {{party?.user?.email}}
                            </div>
                            <div class="flex-column full-column sub-text-label" *ngIf="party?.workspace?.phone">{{party?.workspace.phone}}</div>
                        </div>
                    </div>
                    <div class="flex-box-column flex-box-column-participant align-items-end right-signature-info-area">
                        <div class="flex-column full-column sub-text-label participant-signature-box">
                            <div class="flex-column full-column participant-signature" *ngIf="party?.recipient_role_detail?.signature_image">
                                <img [src]="party?.recipient_role_detail?.signature_image | signingPageImage:roleId | async">
                            </div>
                            <div class="signature-bottom-info">
                                <ng-container *ngIf="party?.recipient_role_detail?.signature_image; else nonSenderSigner">
                                    <div class="flex-column full-column sub-text-label">
                                        <span>{{t("Verification initiated on date (Verification page) - Initiated on")}}: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>
                                    </div>
                                </ng-container>
                                <ng-template #nonSenderSigner>
                                    <div class="flex-column full-column sub-text-label">
                                        <span>{{t("Verification initiated on date (Verification page) - Initiated on")}}: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>
                                    </div>
                                </ng-template> 
                            </div>
                        </div>
                    </div>
                    </div>
                </ng-container>
                <ng-template #nonSender>
                    <div class="verification-document-column-participant">
                        <div class="flex-box-column flex-box-column-participant">
                            <div class="participant-info-box">
                                <ng-container *ngIf="party?.personfields | getRecipient : 'object' as recipient">

                                    <!-- Contact Name (PersonalNR) [Role Badge] -->
                                    <div class="flex-row full-column participant-name">
                                        <span>{{ recipient?.firstname }} {{ recipient?.lastname || '' }}</span>

                                        <span *ngIf="recipient?.persnol_no">
                                            ({{ recipient?.persnol_no }})
                                        </span>

                                        <span class="badge badge-light-success">
                                            {{ (status[party?.recipient_role_detail?.status] || party?.recipient_role_detail?.status) | titlecase }}
                                        </span>
                                    </div>

                                    <!-- Contact Email -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="recipient?.email">
                                        {{ recipient?.email }}
                                    </div>

                                    <!-- Contact Address, Zip, City -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="recipient?.address || recipient?.zipcode || recipient?.city">

                                        <span *ngIf="recipient?.address">{{ recipient?.address }}</span>
                                        <span *ngIf="recipient?.address && (recipient?.zipcode || recipient?.city)">
                                            ,
                                        </span>
                                        <span *ngIf="recipient?.zipcode">{{ recipient?.zipcode }}</span>
                                        <span *ngIf="recipient?.zipcode && recipient?.city">
                                            ,
                                        </span>
                                        <span *ngIf="recipient?.city">{{ recipient?.city }}</span>
                                    </div>

                                    <!-- Contact Telephone -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="recipient?.phone_no">
                                        {{ recipient?.phone_no }}
                                    </div>

                                </ng-container>

                                <ng-container *ngIf="party?.orgfields | getOrganization as organization">

                                    <!-- Org Name (RegNR) -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="organization?.name || organization?.register_no">
                                        <span *ngIf="organization?.name">
                                            {{ organization?.name }}
                                        </span>

                                        <span *ngIf="organization?.register_no">
                                            ({{ organization?.register_no }})
                                        </span>
                                    </div>

                                    <!-- Org Address, ZIP, City -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="organization?.address || organization?.zipcode || organization?.city">
                                        <span *ngIf="organization?.address">
                                            {{ organization?.address }}
                                        </span>
                                        <span *ngIf="organization?.address && (organization?.zipcode || organization?.city)">
                                            ,
                                        </span>
                                        <span *ngIf="organization?.zipcode">
                                            {{ organization?.zipcode }}
                                        </span>
                                        <span *ngIf="organization?.zipcode && organization?.city">
                                            ,
                                        </span>
                                        <span *ngIf="organization?.city">
                                            {{ organization?.city }}
                                        </span>
                                    </div>

                                    <!-- Org Telephone -->
                                    <div class="flex-column full-column sub-text-label" *ngIf="organization?.phone">
                                        {{ organization?.phone }}
                                    </div>

                                </ng-container>
                            </div>
                        </div>

                        <div class="flex-box-column flex-box-column-participant align-items-end right-signature-info-area">
                            <div class="flex-column full-column sub-text-label participant-signature-box">
                                <div class="flex-column full-column participant-signature" *ngIf="party?.recipient_role_detail?.signature_image">
                                    <img [src]="party?.recipient_role_detail?.signature_image | signingPageImage:roleId | async">
                                </div>

                                <div class="signature-bottom-info">
                                    <div class="flex-column full-column sub-text-label">
                                        <ng-container *ngIf="(party?.authentication_type === authenticationTypeEnum.BANKID && (party?.recipient_role_detail?.status === signingStatusEnum.SIGNED || party?.recipient_role_detail?.status === signingStatusEnum.COMPLETED)); else nonBankid">
                                            <span>{{t("Verification signed with text (Verificaton page) - Signed with")}} <img src="../../assets/images/bankId-icon.png"> BankID: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>
                                        </ng-container>
                                        <ng-template #nonBankid>
                                            @if (party?.authentication_type == authenticationTypeEnum.ATTEST) {
                                                <span>{{t("Verification approved on text (Verificaton page) - Approved on")}}: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>       
                                            }@else if (party?.recipient_role_detail?.status == signingStatusEnum.FORWARDED) {
                                                <span>{{t("Verification forwarded on text (Verificaton page) - Forwarded on")}}: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>       
                                            }@else if (party?.authentication_type === authenticationTypeEnum.NORWEGIANBANKID) {
                                                <span>{{t("Verification signed with text (Verificaton page) - Signed with")}} <img src="../../assets/images/authentication-icons/norwegian_bank_id.svg"> Norwegian BankId: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>       
                                            }@else if (party?.authentication_type === authenticationTypeEnum.DANISHMITID) {
                                                <span>{{t("Verification signed with text (Verificaton page) - Signed with")}} <img src="../../assets/images/authentication-icons/mitId-logo-blue.png" height="35px" style="width: 60px;"></span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>       
                                            }@else if(party?.authentication_type === authenticationTypeEnum.FINNISHBANKID) {
                                                <span>{{t("Verification signed with text (Verificaton page) - Signed with")}} <img src="../../assets/images/addons-images/finlandIDIcon.png" height="35px" style="width: 35px;"></span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>
                                            }@else if(party?.recipient_role_detail?.status !== authenticationTypeEnum.READONLY) {
                                                <span>{{t("Verification signed text (Verification page) - Signed")}}: </span> <span class="ps-25">{{party?.recipient_role_detail?.status_updated_at | dateFormat | async}}</span>
                                            }
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>    
            }
        </div>
    </div>

    <app-registered-events [roleId]="roleId" [document_id]="document_id" [is_sender]="is_sender" [roleDetail]="roleDetail"></app-registered-events>
        <div id="footer" class="verification-document-row verification-page-footer-area footer mt-1 footer">
            <div class="verification-page-footer-left">
                <img alt="footer-verification-logo" src="assets/images/logo/simplesignSquareIcon.svg">
                <div class="">
                    <h5 class="mb-50 mt-25">{{t("Verification powered by SimpleSign text (Verificaton page) - Powered by SimpleSign")}}</h5>
                    <p class="m-0">{{t("Verification footer message (Verification page) - SimpleSign is a leading document workflow and eSignature solution, trusted by global companies for its certification")}}.</p>
                </div>
            </div>

            <div class="verification-page-footer-right">
                <div class="verification-qrcode">
                    <qrcode [qrdata]="appUrl" [width]="80" [errorCorrectionLevel]="'M'"></qrcode>
                </div>
            </div>
        </div>
</div>
</ng-container>
